export default {
  stylefactor_momentum: 'Style Factor Momentum',
  stylefactor_value: 'Style Factor Value',
  stylefactor_growth: 'Style Factor Growth',
  stylefactor_credit: 'Style Factor Credit',
  stylefactor_liquidity: 'Style Factor Liquidity',
  stylefactor_size: 'Style Factor Size',
  stylefactor_volatility: 'Style Factor Volatility',
  stylefactor_other: 'Style Factor Other',
};